import { flow, types } from "mobx-state-tree";
import customtypes from "../../utils/mobx-types-helper";

export const FileModel = types
    .model("FileModel", {
        id: types.maybeNull(types.number),
        fileDetail: customtypes.optional(types.string, ""),
        fileName: customtypes.optional(types.string, ""),
        fileExtension: customtypes.optional(types.string, ""),
        fileSize: customtypes.optional(types.number, 0),
        fileData: customtypes.optional(types.string, ""),
        clearFile: customtypes.optional(types.boolean, false),
    })
    .views((self: any) => ({
        get file() {
            return self.fileName;
        },
    }))
    .actions((self: any) => ({
        setToBase64Format: (file: File) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                self.setAllField({
                    id: null,
                    fileDetail: "",
                    fileName: file.name,
                    fileExtension: file.name.split(".").pop(),
                    fileSize: file.size,
                    fileData: (reader.result as string).split(",")[1],
                    clearFile: false,
                });
            };
            reader.onerror = (error) => {
                throw error;
            };
        },
        setAllField: (file: any) => {
            self.id = file.id;
            self.fileDetail = file.fileDetail;
            self.fileName = file.fileName;
            self.fileExtension = file.fileExtension;
            self.fileSize = file.fileSize;
            self.fileData = file.fileData;
            self.clearFile = file.clearFile;
        },
    }));

export type IFileModel = typeof FileModel.Type;
